/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![CirclePlayIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABnklEQVR4nMVVPUsDQRBdYqF2JmUUEcSfoK1lDvZ2ZiPczRCLMyr4D0Qi/iSTVFr4C1TUMhE7tU+M9sqemrt83W0+0IUHV9y+tztv5q0Q/7k8z8uB5n1ArivNTdD0YfDzXQPwy1KWspMQL4KmU9D0Bpo/k6CQ2wqpYvZYkQNwHpBv0oihX0jTg+t6q4nkxeLuCmh+HZccurehFym95dFlQb6blByim9xuB8HCgIBCOpuWHLqgk/7T55IMVZpcx9HrCv0Lu1Jxu6e7wlZM2CCEyPxCIR0YAgs/9iIB5LqtgBAiUyjgmkK6SvGiGr/B0zgC4htzLvpHSnNnuAA3I4NH/JQiEMJ1/c0RAp2ZCEjpbaULID/OukSA1Ih5QLVZmwzI57H88cuWAnMu+odWIag56Bm0pN520VdS7mwA0qXVoGlqIQZL/VFRsdkMdpN8PJBFJqBMUE1PTtdDw84sE7Umcicm1/xs3pOh5JHhnDenGJ+c7lMfnHi5TORahZqmlqm54zjzVuS9JStlTSqGc4LUUMjvBuG3pqppxYFu+ev1BcYurzVsGYvqAAAAAElFTkSuQmCC)
 */
export const CirclePlayIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = 'transparent',
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22ZM9 8.09c0-.88 1-1.4 1.73-.9l5.8 3.91c.63.44.63 1.36 0 1.8l-5.8 3.9C10 17.3 9 16.8 9 15.92V8.1Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
